<template>
  <div>
    <div class="navbar nav-main w-100" style="background-color: #23409a; color: white">
      <h3 class="w-100 text-center my-3">ลงทะเบียนใช้งาน</h3>
    </div>
    <div class="w-100 session-with-nav" style="height: calc(100vh - 67px); overflow: auto">
      <div style="text-align: right" class="mr-2 mt-2">
        <v-btn color="#23409a" outlined icon @click="pop = true">
          <span class="fs-20 text-blue">?</span>
        </v-btn>
      </div>
      <v-dialog v-model="pop" :overlay="false" max-width="500px" transition="dialog-transition">
        <v-card class="py-2 px-5">
          <div class="text-center">
            OTP คือ รหัสที่ส่งผ่านระบบ SMS (ข้อความ) ตามเบอร์โทรศัพท์ที่แจ้งไว้
          </div>
          <div style="text-align: center" class="mt-2">
            <v-btn color="#23409a" @click="askmore">
              <span class="text-white">สอบถามเพิ่มเติม</span>
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
      <div class="mb-3 flex-all-center">
        <div>
          <v-img
            class="my-5 radius-circle"
            style="width: 70vw; height: auto"
            src="@/assets/rafiki.png"
          ></v-img>
        </div>
      </div>
      <div class="w-100 px-8">
        <div class="text-center">
          ระบบได้ทำการส่งรหัส OTP ไปยังเบอร์โทรศัพท์ของท่าน {{ showPhoneno }}
        </div>
        <div class="fs-14 text-gray text-center mt-2">
          <span>Ref :</span>
          <span class="mx-1" v-if="ref">{{ ref.otpRefNo }}</span>
          <CountDownTimer
            :key="`count-down-timer-${resetTimer}`"
            class="mx-1"
            style="font-size: 14px"
            v-if="showCountdowntimer"
            :startmin="timeleft"
            @ontimeout="showCountdowntimer = false"
          ></CountDownTimer>
          <div class="mt-5">
            <custom-input
              :maxlength="6"
              v-model="otp"
              :center="true"
              placeholder="OTP"
              numberOnly
              outlined
            ></custom-input>
          </div>
          <div style="color: black">
            <div>
              ไม่ได้รับรหัส OTP
              <span @click="sentOtp" class="text-blue" style="text-decoration: underline"
                >ส่งใหม่อีกครั้ง</span
              >
            </div>
            <div class="mt-2">
              หรือ
              <span
                @click="sendMessageChagePhoneOtp"
                class="text-blue"
                style="text-decoration: underline"
                >เปลี่ยนเบอร์โทรศัพท์ที่รับ OTP</span
              >
            </div>
          </div>
        </div>
        <div class="flex-all-center mt-8 mb-5">
          <v-btn
            :loading="loading"
            @click="nextRegis"
            class="col-8 main-btn"
            style="color: white"
            color="#23409a"
            >ถัดไป</v-btn
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CountDownTimer from '@/components/CountDownTimer.vue'
import moment from 'moment'
import otpApi from '@/api/otp'
import config from '@/config'
import { mapGetters } from 'vuex'
import consendApi from '@/api/consend'
import { formatThaiDate } from '@/utils/dateFormat'

export default {
  components: { CountDownTimer },
  data() {
    return {
      pop: false,
      otp: '',
      timeleft: 5,
      loading: false,
      checkbox: false,
      showCountdowntimer: true,
      resetTimer: 1
    }
  },
  async mounted() {
    await this.fetchConsend()
  },
  computed: {
    ...mapGetters(['regisList']),
    idcard() {
      return this.$store.state.regisData.idcard
    },
    query() {
      return this.$store.state.query
    },
    view() {
      return this.$store.state.query.view
    },
    input() {
      return this.$store.state.regisData ? this.$store.state.regisData : null
    },
    ref() {
      return this.$store.state.ref
    },
    userId() {
      return this.$store.getters.getUserid
    },
    showPhoneno() {
      if (
        this.$store.state?.regisData?.phoneno &&
        this.$store.state?.regisData?.phoneno.length === 10
      ) {
        let phone = this.$store.state?.regisData?.phoneno
        let data = [phone[0], phone[1], phone[2], '-xxx-', phone[6], phone[7], phone[8], phone[9]]
        return data.join('')
      } else {
        return this.$store.state?.regisData?.phoneno ? this.$store.state?.regisData?.phoneno : ''
      }
    }
  },
  methods: {
    async sentOtp() {
      if (this.$store.state?.regisData?.phoneno) {
        this.$emit('resend', this.$store.state?.regisData?.phoneno)
        this.resetTimer++
        this.showCountdowntimer = true
      } else {
        this.$swal.fire({
          type: 'error',
          text: 'ไม่พบเบอร์โทรศัพท์'
        })
      }
    },
    async sendMessageChagePhoneOtp() {
      await this.$store.dispatch('sendMessage', 'เปลี่ยนเบอร์โทรศัพท์ที่ได้รับ OTP')
      this.$liff.closeWindow()
    },
    async askmore() {
      await this.$store.dispatch('sendMessage', 'สอบถามเพิ่มเติมเรื่อง OTP')
      this.$liff.closeWindow()
    },
    async nextRegis() {
      let configData = {
        body: {
          page_id: config.pageid,
          user_id: this.$store.state.userid,
          otp_ref_no: this.ref.otpRefNo,
          otp: this.otp,
          phone_number: this.input.phoneno,
          id_card: this.input.idcard,
          birth_day: formatThaiDate(this.input.date),
          status: this.$store.state.regisData.status,
          etaxebill_ncap: this.$store.state.hasEtaxBill ? 'regis' : 'noregis',
          etaxebill_nmny: this.$store.state.hasNmEtaxBill ? 'regis' : 'noregis'
        }
      }
      try {
        this.loading = true
        let res = await otpApi.postRegister(configData)
        this.loading = false
        this.$store.state.showData = res?.data?.data?.ncapLoanList || []
        this.$store.state.nmShowData = res?.data?.data?.nmnyLoanList || []
        await this.$store.dispatch('sendMessage', 'ผูกบัญชีสำเร็จ')
        this.loading = true
        await this.saveConsend()
        this.loading = false
        this.$emit('next')
      } catch (error) {
        console.error(error)
        this.$swal.fire({
          type: 'error',
          text: 'กรอกรหัส OTP ไม่ถูกต้อง กรุณาลองใหม่อีกครัั้ง'
        })
      } finally {
        this.loading = false
      }
    },
    async saveConsend() {
      try {
        const { displayName, userId } = this.profile
        if (
          this.regisList &&
          this.regisList.version &&
          this.regisList.version.hpmc &&
          this.regisList.version.mkt &&
          this.regisList.version.mktPdpa &&
          this.regisList.version.tc
        ) {
          await consendApi.postUserConsendV2({
            body: {
              page_id: config.pageid,
              next_body: [
                {
                  ConsentType: 'Consent_PDPA_HPMC',
                  lineName: displayName,
                  userId: userId,
                  version: this.regisList.version.hpmc,
                  companyKey: 'NCAP',
                  ConsentItemId: 'HPMC',
                  answer: 'Y'
                },
                {
                  ConsentType: 'Consent_PDPA_MKT',
                  lineName: displayName,
                  userId: userId,
                  version: this.regisList.version.mkt,
                  companyKey: 'NCAP',
                  ConsentItemId: 'MKT',
                  answer: this.regisList.answer.mkt || 'N'
                },
                {
                  ConsentType: 'Consent_PDPA_MKTPDPA',
                  lineName: displayName,
                  userId: userId,
                  version: this.regisList.version.mktPdpa,
                  companyKey: 'NCAP',
                  ConsentItemId: 'MKTPDPA',
                  answer: this.regisList.answer.mktPdpa || 'N'
                },
                {
                  ConsentType: 'Consent_TC_NextConnect',
                  lineName: displayName,
                  userId: userId,
                  version: this.regisList.version.tc,
                  companyKey: 'NCAP',
                  ConsentItemId: 'T&C_HPMC',
                  answer: this.regisList.answer.tc || 'Y'
                }
              ]
            },
            config: {}
          })
        } else {
          throw new Error('invalid version')
        }

        if (
          this.regisList.version.nmPp &&
          this.regisList.version.nmMkt &&
          this.regisList.version.nmMktPdpa
        ) {
          try {
            await consendApi.postUserConsendV2({
              body: {
                page_id: config.pageid,
                next_body: [
                  {
                    ConsentType: 'Consent_NMNY_Privacy_Policy',
                    lineName: displayName,
                    userId: userId,
                    version: this.regisList.version.nmPp,
                    companyKey: 'NMNY',
                    ConsentItemId: 'Consent_NMNY_Privacy_Policy',
                    answer: this.regisList.answer.nmPp || 'Y'
                  },
                  {
                    ConsentType: 'Consent_PDPA_MKT',
                    lineName: displayName,
                    userId: userId,
                    version: this.regisList.version.nmMkt,
                    companyKey: 'NMNY',
                    ConsentItemId: 'MKT',
                    answer: this.regisList.answer.nmMkt
                  },
                  {
                    ConsentType: 'Consent_PDPA_MKTPDPA',
                    lineName: displayName,
                    userId: userId,
                    version: this.regisList.version.nmMktPdpa,
                    companyKey: 'NMNY',
                    ConsentItemId: 'MKTPDPA',
                    answer: this.regisList.answer.nmMktPdpa
                  }
                ]
              },
              config: {}
            })
          } catch (error) {
            this.$swal.fire({
              type: 'error',
              text:
                'ขณะนี้บัญชีของท่านไม่มีสัญญาของ Next Money การยินยอมนโยบายความเป็นส่วนตัวจะมีผลเฉพาะกับบริษัทที่มีข้อมูลผู้ใช้เท่านั้น'
            })
          }
        }
      } catch (error) {
        this.$swal.fire({
          type: 'error',
          text: 'บันทึกข้อมูลนโยบายความเป็นส่วนตัวไม่สำเร็จ'
        })
      }
    },
    async fetchConsend() {
      try {
        this.loading = true
        const responseConsendList = await consendApi.getUserConsend({
          page_id: config.pageid,
          line_id: this.userId
        })
        if (responseConsendList && responseConsendList.data && responseConsendList.data.data) {
          const dataPool = responseConsendList.data.data
          this.setConsendData(dataPool)
        }
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    setConsendData(dataPool) {
      const nextCapData = dataPool.find(
        company => company.companyKey == 'NCAP' && company.activeStatus == true
      )
      if (nextCapData && nextCapData.consent && nextCapData.consent.length) {
        let objData = {}
        nextCapData.consent.forEach(consend => {
          objData[consend.consentType] = consend
        })
        this.nextCapConsent = objData
        if (
          objData['Consent-E-TAX'] &&
          objData['Consent-E-TAX'].answer &&
          objData['Consent-E-TAX'].answer == 'Y'
        ) {
          this.$store.state.hasEtaxBill = true
        } else {
          this.$store.state.hasEtaxBill = false
        }
      }
      const nextMoneyData = dataPool.find(
        company => company.companyKey == 'NMNY' && company.activeStatus == true
      )
      if (nextMoneyData && nextMoneyData.consent && nextMoneyData.consent.length) {
        let objData = {}
        nextMoneyData.consent.forEach(consend => {
          objData[consend.consentType] = consend
        })
        this.nextCapConsent = objData
        if (
          objData['Consent-E-Bill'] &&
          objData['Consent-E-Bill'].answer &&
          objData['Consent-E-Bill'].answer == 'Y'
        ) {
          this.$store.state.hasNmEtaxBill = true
        } else {
          this.$store.state.hasNmEtaxBill = false
        }
      }
    }
  }
}
</script>

<style>
.v-tooltip__content {
  background-color: #fafafa !important;
  color: black !important;
  max-width: 80%;
  border: 1px solid #ebebeb !important;
  box-sizing: border-box !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
  border-radius: 10px !important;
}
.v-application .primary--text {
  color: #23409a !important;
  caret-color: #23409a !important;
}
.slidedealer,
.slidedealer-back {
  &-enter-active,
  &-leave-active {
    position: absolute;
    width: 100%;
    background: white;
    min-height: 100vh;
    top: 12px;
  }
}
// router view
.slidedealer-enter-active {
  transition: transform $duration ease-in-out;
  z-index: 2;
  transform: translateX(100%);
}
.slidedealer-enter-to {
  z-index: 2;
  transform: translateX(0%);
}
.slidedealer-leave-active {
  z-index: -1;
}
.slidedealer-leave-to {
  z-index: -1;
}
// router view back

.slidedealer-back-enter-active {
  z-index: -1;
}
.slidedealer-back-enter-to {
  z-index: -1;
}

.slidedealer-back-leave-active {
  transition: transform $duration ease-in-out;
  z-index: 2;
  transform: translateX(0%);
}
.slidedealer-back-leave-to {
  transform: translateX(100%);
  z-index: 2;
}
.addcartbtn {
  position: fixed;
  text-align: center;
  padding-top: 15px;
  z-index: 1;
  font-size: 23px;
  bottom: 0px;
  background-color: rgb(12, 77, 157);
  width: 90vw;
  height: 60px;
  color: white;
  border-radius: 13px 13px 0px 0px;
  left: 50%;
  transform: translate(-50%, 0);
}
.myshadow {
  -webkit-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.65);
  box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.95);
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
